<!--
 * @Author: wh
 * @Date: 2020-07-27 10:49:11
 * @LastEditTime: 2020-07-30 09:52:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\customerTerminal\feedback\newFeedback.vue
-->
<template>
    <div class="newFeedback">
        <van-nav-bar
            title="意见反馈详情"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        >
        </van-nav-bar>
        <section>
            <van-form>
                <van-cell
                    title="客户名称"
                    :icon="require('@/assets/images/icons/icon_3.png')"
                    :value="formData.ClientName"
                ></van-cell>
                <van-cell
                    title="合同编号"
                    :icon="require('@/assets/images/icons/icon_gy_1.png')"
                    :value="formData.ContractNumber"
                ></van-cell>
                <van-cell
                    title="工程名称"
                    :icon="require('@/assets/images/icons/icon_gy_3.png')"
                    :value="formData.EngineeringName"
                ></van-cell>
                <van-cell
                    title="签订日期"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                    :value="formData.SigningDate"
                ></van-cell>
                <van-cell
                    title="供料时间"
                    :icon="require('@/assets/images/icons/icon_gy_7.png')"
                    :value="formData.SupplyFirstTime"
                ></van-cell>
                <van-cell
                    title="已供方量"
                    :icon="require('@/assets/images/icons/icon_6.png')"
                    :value="formData.SupplyVolume"
                ></van-cell>
                <van-cell
                    title="问题/建议"
                    :icon="require('@/assets/images/icons/icon_34.png')"
                ></van-cell>
                <van-field
                    rows="4"
                    autosize
                    type="textarea"
                    maxlength="80"
                    class="iconfont iconbeizhu textarea"
                    placeholder="问题/建议"
                    v-model="formData.Describe"
                    disabled
                ></van-field>
                <van-cell
                    title="联系人"
                    :icon="require('@/assets/images/icons/icon_3.png')"
                    :value="formData.Contacts"
                ></van-cell>
                <van-cell
                    title="企业反馈"
                    :icon="require('@/assets/images/icons/icon_gy_4.png')"
                ></van-cell>
                <van-field
                    rows="4"
                    autosize
                    type="textarea"
                    maxlength="80"
                    class="iconfont iconbeizhu textarea"
                    placeholder="企业反馈"
                    v-model="formData.Reply"
                    disabled
                ></van-field>
                <van-cell
                    title="反馈日期"
                    :icon="require('@/assets/images/icons/icon_6.png')"
                    :value="formData.ReplyTime"
                ></van-cell>
            </van-form>
        </section>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            formData: {},
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.formData = this.$route.params.infoData;
    },
    methods: {
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="stylus">
.newFeedback
    height 100%
    section
        height calc(100% - 45rpx)
        overflow scroll
        -webkit-overflow-scrolling touch
        .van-cell:not(:last-child)::after
            left 0
        .van-cell
            font-size 15rpx
            .iconbeizhu:before
                margin-right 5rpx
        .textarea
            border 1px solid #ebedf0
            margin 10rpx
            width calc(100% - 20rpx)
            border-radius 5rpx
</style>